export const Name = 'request-clear-shopping-cache';
export const RequestClearShoppingCacheEvent = Name;
//# sourceMappingURL=index.js.map